<div [ngStyle]="{top: top, left: left}" class="tooltip-container">
    <ng-content></ng-content>
</div>
